import { render } from "./NewsInfo.vue?vue&type=template&id=584e8afd&scoped=true&ts=true"
import script from "./NewsInfo.vue?vue&type=script&lang=ts"
export * from "./NewsInfo.vue?vue&type=script&lang=ts"

import "./NewsInfo.vue?vue&type=style&index=0&id=584e8afd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584e8afd"]])

export default __exports__